import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import ArrowLongLeftIcon from "@heroicons/react/24/outline/ArrowLongLeftIcon";
import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  activeStep: number;
  isLastStep: boolean;
  handleNext: () => void;
  handlePrev: () => void;
  isThisValidStep: (step: number) => boolean;
  errorMessage: string;
}

export default function QuoteBottomBar(props: Props) {
  const { t } = useTranslation();
  const {
    activeStep,
    errorMessage,
    isLastStep,
    handlePrev,
    handleNext,
    isThisValidStep,
  } = props;
  const router = useRouter();

  function backPage() {
    router.back();
  }

  return (
    <div className="w-full z-20 fixed md:absolute px-2 left-0 bottom-0 h-[62px] bg-white md:rounded-bl-3xl md:rounded-br-3xl shadow-xl justify-start items-center gap-2.5 inline-flex">
      <div
        className={`flex items-center gap-2 ${isLastStep ? "hidden" : ""
          } w-full`}
      >
        {activeStep > 0 && (
          <Button
            onClick={handlePrev}
            variant="white"
            className="!min-w-[110px] !px-1"
          >
            <ArrowLongLeftIcon className="size-4" />
            Geri Dön
          </Button>
        )}

        <Button
          id="quote-next-step-button"
          disabled={!isThisValidStep(activeStep) && activeStep !== 1}
          onClick={() => {
            if (isThisValidStep(activeStep)) {
              handleNext();
            }
          }}
          className={cn(
            `w-full`,
            !isThisValidStep(activeStep) && "cursor-not-allowed opacity-50",
          )}
          variant="accent"
        >
          {activeStep === 0 ? "Gönder" : t("user-register-continue-button")}
        </Button>
      </div>

      <div
        className={`flex items-center gap-2 ${!isLastStep ? "hidden" : ""
          } w-full`}
      >
        <Button onClick={backPage} className="w-full">
          Kapat
        </Button>
      </div>
    </div>
  );
}
